import { If } from "@components/control-statements";
import useEventListener from "@hooks/useEventListener";
import { FlowStorage } from "@storage/FlowStorage";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import React, { useEffect, useState } from "react";

export const ReportFooter = ({ id }) => {
  const [hasReport, setHasReport] = useState(false);
  const [emails, setEmails] = useState(null);
  const [phones, setPhones] = useState(null);

  useEffect(() => {
    const report = FlowStorage.getLastBoxExecution(id) || {};
    setHasReport(!!report.box_id && report.state != "ERROR");
    setEmails(Number(report?.emails).toLocaleString());
    setPhones(Number(report?.phones).toLocaleString());
  }, []);

  useEventListener("LOADED_FLOW_REPORT", () => {
    const report = FlowStorage.getLastBoxExecution(id) || {};
    setHasReport(!!report.box_id && report.state != "ERROR");
    setEmails(Number(report?.emails).toLocaleString());
    setPhones(Number(report?.phones).toLocaleString());
  });

  return (
    <If cond={hasReport}>
      <div className={style.subline}>
        <div className="d-flex">
          <div className="mr-10">
            <i className={"far fa-phone mr-5"}>&nbsp;</i>
            {phones}
          </div>
          <div>
            <i className={"far fa-envelope-open mr-5"}>&nbsp;</i>
            {emails}
          </div>
        </div>
      </div>
    </If>
  );
};
